import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function MrpMaterialEventData(props) {
    const { mrpMaterialListSelect, onEventDataLoad } = props;

    const view = "MrpVwMaterialEventData";

    const [, setMrpMaterialEventDataSelect] = useState();
    const [, setMrpMaterialEventDataIsEmpty] = useState();
    const [mrpMaterialEventDataList, setMrpMaterialEventDataList] = useState([]);
    const [mrpMaterialEventDataGrid, setMrpMaterialEventDataGrid] = useState();
    const [, setMrpMaterialEventDataApi] = useState();

    const { t } = useTranslation();

    useEffect(() => {
        setMrpMaterialEventDataApi((api) => {
            if (api) {
                api.refresh();
            }

            return api;
        });
    }, [mrpMaterialListSelect.materialCode, mrpMaterialListSelect.materialCodeVer]);

    useEffect(() => {
        let mounted = true;

        (async () => {
            if (mrpMaterialEventDataGrid && mounted) {
                mrpMaterialEventDataGrid.selectionChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        setMrpMaterialEventDataSelect(grid.selectedItems[0]);
                    }
                });

                mrpMaterialEventDataGrid.itemsSourceChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        setMrpMaterialEventDataSelect(grid.selectedItems[0]);
                    }
                });
            }
        })();

        return () => {
            mounted = false;
        };
    }, [mrpMaterialEventDataGrid]);

    useEffect(() => {
        if (
            mrpMaterialListSelect &&
            mrpMaterialEventDataGrid &&
            mrpMaterialEventDataList &&
            mrpMaterialEventDataList?.length > 0 &&
            mrpMaterialListSelect.materialCode === mrpMaterialEventDataList[0].eventMaterialCode &&
            mrpMaterialListSelect.materialCodeVer === parseInt(mrpMaterialEventDataList[0].eventMaterialCodeVer)
        ) {
            let netQty = mrpMaterialListSelect.qtyCurrent;

            for (const item of mrpMaterialEventDataList) {
                netQty += item.eventQty;
                item.netQty = netQty;
            }

            if (onEventDataLoad) {
                onEventDataLoad(mrpMaterialEventDataList);
            }

            /*** 2022/08/16 itkim : grid.refresh() is useless            
            mrpMaterialEventDataGrid.refresh(false); // false : refresh grid content only
            ***/

            /***
            if (onUpdateMaster) {
                onUpdateMaster(mrpMaterialEventDataList);
            }
            ***/
        }
    }, [mrpMaterialListSelect, mrpMaterialEventDataGrid, mrpMaterialEventDataList, onEventDataLoad]);

    return (
        <BasicCrudScreenType
            id="MrpVwMaterialEventData"
            headerTitle={t("term.mrpMaterialEventData")}
            view={view}
            noCreate
            noEdit
            noDelete
            noExcel
            onModifyViewUrl={(url) =>
                `${url}/${mrpMaterialListSelect.materialCode}/${mrpMaterialListSelect.materialCodeVer}`
            }
            onInitialized={(grid) => {
                grid.selectionMode = "Row";
                setMrpMaterialEventDataGrid(grid);
            }}
            onApiInitialized={(api) => {
                setMrpMaterialEventDataApi(api);
            }}
            onLoadData={(data) => {
                setMrpMaterialEventDataIsEmpty(data.length < 1 ? true : false);
                setMrpMaterialEventDataList(data);
            }}
        />
    );
}

export default MrpMaterialEventData;
